
const websocketUrl = 'https://chat.hyderabadcastingclub.com';
// const websocketUrl = 'http://localhost:3001/';

export default websocketUrl;